<template>
	<div class="skincare">
		<Loading msg="loading" v-if="!isload" />
		<div class="skincare_inner" v-else>
      		<img @click="$parent.goBack()"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
            <!-- 皮肤分析 -->
            <div class="skincare_head">
                <h1 class="head_title">护肤方案/<span class="title_sub">&nbsp;结合基因和现状推荐</span></h1>
                <h6 class="second_title">皮肤分析</h6>
                 <div class="result_sub">{{skincare_data.title}}</div>
                 <p class="result_sub_info">{{skincare_data.title_next}}</p>
                 <!-- 基因和表型都没有标签时不展示 -->
                <div class="head_result_part" v-if="(!(skincare_data.reason_1_show == 0)) || (!(skincare_data.reason_2_show == 0))">
                   
                    <div class="head_result_part_title">原因说明</div>
                      <!-- 基因结果 -->
                        <div class="result_info" v-if="!(skincare_data.reason_2_show == 0)">
                            <p class="result_info_text">偏弱基因项目</p>
                            <ul class="info_list">
                                <li class="list_item weak_gene" v-for="(type_item,type_idx) in skincare_data.message2" :key="type_idx" @click="$parent.routerGo('/genedetail/'+type_item.type_id,(actParams = { query: $route.query, pageid: 414 }),{is_access:true,reportEvent_page_id:414,reportEvent_page_name:'护肤方案-偏弱基因项目-跳转基因详情页',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'偏弱基因'})"><span>{{type_item.result}}</span><img src="../assets/images/arrow_to_detail.png" alt=""></li>
                                <!-- <li class="list_item weak_gene"><span>抗氧化能力弱</span><img src="../assets/images/arrow_right_icon.png" alt=""></li> -->
                            </ul>
                        </div>
                        <!-- 现状结果 -->
                        <div class="result_info" v-if="!(skincare_data.reason_1_show == 0)">
                           <p class="result_info_text">现状情况<span>(来自生活问卷)</span></p>
                            <ul class="info_list">
                                <li class="list_item" v-for="(pheno_item,pheno_idx) in skincare_data.message1" :key="pheno_idx">{{pheno_item}}</li>
                                <!-- <li class="list_item">爱吃甜食</li> -->
                            </ul>
                        </div>
                    

                </div>
            </div>

            <!-- 功效成分 -->
            <div class="skincare_ing">
                <h6 class="ing_title">适用成分精选</h6>
                <div class="ing_list">
                    <ul class="ing_list_ul">
                        <li class="ing_list_item" v-for="(ing,ing_idx) in skincare_data.component_info" :key="ing_idx" @click="displayIng(ing);">
                            <img :src="ing.component_img" class="ing_list_item_pic" :key="ing.component_img" alt="">
                            <p class="ing_list_item_name">{{ing.component_name}}</p>
                        </li>
                         <!-- <li class="ing_list_item">
                            <img src="../assets/images/2.png" class="ing_list_item_pic" alt="">
                            <p class="ing_list_item_name">烟酰胺</p>
                        </li>
                         <li class="ing_list_item">
                            <img src="../assets/images/3.png" class="ing_list_item_pic" alt="">
                            <p class="ing_list_item_name">烟酰胺</p>
                        </li>
                         <li class="ing_list_item">
                            <img src="../assets/images/4.png" class="ing_list_item_pic" alt="">
                            <p class="ing_list_item_name">烟酰胺</p>
                        </li> -->
                    </ul>
                </div>

            </div>

            <!-- 适合精华 -->
            <div class="skincare_serum">
                <h6 class="serum_title">适用精华推荐</h6>
                <div class="serum_info" @click="$parent.goMallDetail(skincare_data.product_info.goods_id);">
                  <img :src="skincare_data.product_info.photo_address" :key="skincare_data.product_info.photo_address" class="serum_info_pic" :style="{'background':serum_color}" alt="">
                  <!-- $parent.trackLog((actParams = { query: $route.query, pageid:skincare_data.product_info.product_page_id }),{is_access:true,reportEvent_page_id:skincare_data.product_info.product_page_id,reportEvent_page_name:skincare_data.product_info.name,reportEvent_report_type:'199基因',reportEvent_first_module:'基因结果',reportEvent_second_module:'产品详情'}); -->
                  <div class="serum_info_name">{{skincare_data.product_info.name.replace('优时颜','')}}</div>
                  <p class="serum_info_effect">{{skincare_data.product_info.gongxiao.join("、")}}</p>
                  <ul class="serum_info_ings">
                    <li class="ing" v-for="(ing,ing_idx) in skincare_data.product_info.component" :key="ing_idx">{{ing}}</li>
                  </ul>
                  <!-- 20190917修改 -->
                  <div class="serum_info_tip"><span>会员专属优惠</span><img src="../assets/images/arrow_right_d.png" alt=""></div>
                </div>
            </div>

            <!-- 护肤搭配 -->
            <!-- 缩略 步骤 -->
            <div class="skincare_rec">
              <h6 class="rec_title">护肤步骤</h6>
                 <div class="rec_step_outer">
                   <ul class="rec_step_ul">
                     <li class="rec_step_li">
                       <div class="step_li_info">
                         <div class="step_li_pic_outer">
                         <img src="../assets/images/Cleanser.png" class="step_li_pic" alt="">
                         </div>
                         <p class="step_li_name">洁面乳</p>
                       </div>
                       <img src="../assets/images/step_li_arrow.png" class="step_li_arrow" alt="">
                     </li>
                      <li class="rec_step_li">
                       <div class="step_li_info">
                         <div class="step_li_pic_outer">
                         <img src="../assets/images/Toner.png" class="step_li_pic" alt="">
                         </div>
                         <p class="step_li_name">护肤水</p>
                       </div>
                       <img src="../assets/images/step_li_arrow.png" class="step_li_arrow" alt="">
                     </li>
                      <li class="rec_step_li">
                       <div class="step_li_info">
                         <div class="step_li_pic_outer">
                         <img :src="skincare_data.product_info.photo_address" :key="skincare_data.product_info.photo_address" class="step_li_pic" alt="">
                         </div>
                         <p class="step_li_name">精华</p>
                       </div>
                       <img src="../assets/images/step_li_arrow.png" class="step_li_arrow" alt="">
                     </li>
                     <li class="rec_step_li">
                       <div class="step_li_info">
                         <div class="step_li_pic_outer">
                         <img src="../assets/images/Lotion.png" class="step_li_pic" alt="">
                         </div>
                         <p class="step_li_name">乳液</p>
                       </div>
                       <img src="../assets/images/step_li_arrow.png" class="step_li_arrow" alt="">
                     </li>
                     <li class="rec_step_li">
                       <div class="step_li_info">
                         <div class="step_li_pic_outer">
                         <img src="../assets/images/EyeCream.png" class="step_li_pic" alt="">
                         </div>
                         <p class="step_li_name">眼霜</p>
                       </div>
                       <img src="../assets/images/step_li_arrow.png" class="step_li_arrow" alt="">
                     </li>
                      <li class="rec_step_li">
                       <div class="step_li_info">
                         <div class="step_li_pic_outer">
                         <img src="../assets/images/Mask.png" class="step_li_pic" alt="">
                         </div>
                         <p class="step_li_name">(面膜)</p>
                       </div>
                       <img src="../assets/images/step_li_arrow.png" class="step_li_arrow" alt="">
                     </li>
                   </ul>
                 </div>

                 <div class="check_rec_detail_btn" @click="$parent.routerGo('/skincarelist',(actParams = { query: $route.query, pageid: 415 }),{is_access:true,reportEvent_page_id:415,reportEvent_page_name:'护肤方案-检测会员价优惠购买（到产品列表）',reportEvent_report_type:'199基因',reportEvent_first_module:'护肤方案',reportEvent_second_module:'优惠购买'})"><span>检测会员价优惠购买</span><img src="../assets/images/arrow_right_c.png" alt=""></div>
            </div>
			
                 <!-- 成分弹窗 -->
        <div class="ing_layer" v-if="show_ing">
            <div class="ing_layer_inner">
                <div class="ing_name">{{ing_obj.component_name}}</div>
                <ul>
                    <li class="ing_desc" v-for="(ing,idx) in ing_obj.tag" :key="idx">●&nbsp;{{ing}}</li>
                    <!-- <li class="ing_desc">●&nbsp;富含氨基酸、维生素</li>
                    <li class="ing_desc">●&nbsp;营养丰富、滋养肌肤</li> -->
                </ul>
                <img src="../assets/images/close_btn.png" class="ing_close_icon" alt="" @click="show_ing = false;">
            </div>
        </div>
		
		</div>

    <!-- 护肤推荐产品列表 -->
    <div class="skincare_rec_detail" v-if="skincare_detail_show">
        <img @click="skincare_detail_show=false;"
				v-lazy="'https://static.inertiabiotech.com/uniskin/reportv3/images/gene_test_back.png'"
				class="back_btn lazy"
				alt="" />
       
        <div class="skincare_rec_detail_title">优时颜基础系列</div>
         <div class="skincare_rec_detail_list_title">
           <div class="detail_list_title_item" @click="show_day_list=true;" :class="show_day_list ? 'now' : ''"><span>早</span></div>
           <div class="detail_list_title_item" @click="show_day_list=false;" :class="(!show_day_list) ? 'now' : ''"><span>晚</span></div>
         </div>
        <!-- 早上护肤列表 -->
        <ul class="morning_list" v-if="show_day_list">
          <template v-for="(m_pro,m_idx) in skincare_data.skin_step.morning">
                    <!-- 早上第一步为推荐产品的情况 -->
          <li class="no_recommend" v-if="!m_pro.name" :key="m_idx">
            <img src="../assets/images/romantic_poster.png" class="no_recommend_pic no_recommend_item" alt="">
            <div class="no_recommend_item no_recommend_info">
            <div class="no_recommend_title">早晨第一步</div>
            <p class="no_recommend_text">用清水洁面</p>
            </div>
          </li>
        <li class="rec_pro_info" :key="m_idx" @click="$parent.goMallDetail(m_pro.goods_id);" v-else>

         
            <img :src="m_pro.photo_address" class="info_item info_pic" alt="">
              <div class="info_item info_detail">
                  <div class="detail_name">{{m_pro.name}}</div>
                    <ul class="detail_effect"><li v-for="(ing,ing_idx) in m_pro.component" :key="ing_idx">{{ing}}</li></ul>
                    <!-- <ul class="detail_tag"><li v-for="(effect,effect_idx) in m_pro.gongxiao" :key="effect_idx">{{effect}}</li></ul> -->
                    <ul class="detail_tag"><li>{{m_pro.gongxiao[0]}}</li></ul>
              </div>
              <div class="info_item info_link"><span class="discount_text">检测会员价</span><img src="../assets/images/arrow_right.png" class="link_icon" alt=""></div>
              
        </li>
        </template>
        </ul>

        <!-- 晚上护肤建议 -->
        <ul class="night_list" v-if="!show_day_list">
        <li class="rec_pro_info" v-for="(e_pro,e_idx) in skincare_data.skin_step.evening" :key="e_idx" @click="$parent.goMallDetail(e_pro.goods_id);">
            <img :src="e_pro.photo_address" :key="e_pro.photo_address" class="info_item info_pic" alt="">
              <div class="info_item info_detail">
                  <div class="detail_name">{{e_pro.name}}</div>
                    <ul class="detail_effect"><li v-for="(ing,ing_idx) in e_pro.component" :key="ing_idx">{{ing}}</li></ul>
                    <!-- <ul class="detail_tag"><li v-for="(effect,effect_idx) in e_pro.gongxiao" :key="effect_idx">{{effect}}</li></ul> -->
                    <ul class="detail_tag"><li>{{e_pro.gongxiao[0]}}</li></ul>
              </div>
              <div class="info_item info_link"><span class="discount_text">检测会员价</span><img src="../assets/images/arrow_right.png" class="link_icon" alt=""></div>
        </li>
        </ul>


    </div>
	</div>
</template>

<script>
import Loading from "./Loading.vue";
import axios from "axios";
var wx = require("weixin-js-sdk");
export default {
  name: "Skincare",
  data() {
    return {
      isload: false,
      in_weapp: false, //是否在小程序
      skincare_detail_show: false,
      show_ing: false, //成分弹窗
      skincare_data: null,
      ing_obj: null,
      serum_color: "", //单独精华背景颜色
      show_day_list: true, // 显示白天护肤列表
      show_night_list: false,
      day_icon_light:
        "https://static.inertiabiotech.com/uniskin/reportv3/images/morning_icon_light.png", //白天浅色图标
      day_icon_dark:
        "https://static.inertiabiotech.com/uniskin/reportv3/images/morning_icon_dark.png", //白天深色图标
      night_icon_light:
        "https://static.inertiabiotech.com/uniskin/reportv3/images/night_icon_light.png",
      night_icon_dark:
        "https://static.inertiabiotech.com/uniskin/reportv3/images/night_icon_dark.png",
      imgs: [
        require("../assets/images/1.png"),
        require("../assets/images/2.png"),
        require("../assets/images/3.png"),
        require("../assets/images/4.png")
      ],
      demopic: require("../assets/images/10.png")
    };
  },

  created() {
    console.log("skincare created", this);
    this.initSkincare();
  },
  mounted() {
    var ua = navigator.userAgent.toLowerCase(),
      that = this;
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      wx.miniProgram.getEnv(res => {
        if (res.miniprogram) {
          console.log("在小程序里");
          that.in_weapp = true;
        }
      });
    }
  },
  methods: {
    goMallDetail: function(pid) {
      if (this.in_weapp) {
        wx.miniProgram.navigateTo({
          url: "/mall-detail/mall-detail?scene=" + pid
        });
      } else {
        location.href =
          "https://www.uniskin.com.cn/homepage/m/pro_detail.html?p=" + pid;
      }
    },
    initSkincare: function() {
      let that = this;
      var local_skincare = JSON.parse(localStorage.getItem("local_skincare"));
      if (local_skincare) {
        afterSkincare(local_skincare);
      } else {
        that
          .$jsonp(
            "https://www.uniskin.com.cn/reportv2/index/gene_july_one/getSkinMethod"
          )
          .then(json => {
            console.log(json);
            afterSkincare(json);
            // localStorage.setItem("local_skincare",JSON.stringify(json));
          })
          .catch(err => {
            console.log(err);
            localStorage.clear();
            location.href =
              "https://www.uniskin.com.cn/mall/member/account/login";
          });
      }
      function afterSkincare(skincare_data) {
        if (skincare_data.code == 0) {
          that.isload = true;
          that.skincare_data = skincare_data.skin_method_info;
          let serum_address =
            skincare_data.skin_method_info.product_info.photo_address;
          if (serum_address.indexOf("TYRA_1") > -1) {
            that.serum_color = "#f2f1e9";
          } else if (serum_address.indexOf("TYRA_2") > -1) {
            that.serum_color = "#e3d2ca";
          } else if (serum_address.indexOf("ROSA_1") > -1) {
            that.serum_color = "#184d72";
          } else if (serum_address.indexOf("ROSA_2") > -1) {
            that.serum_color = "#000";
          } else if (serum_address.indexOf("ROSA_3") > -1) {
            that.serum_color = "#76151a";
          } else {
            that.serum_color = "transparent";
          }
        }
      }
    },
    displayIng: function(ing) {
      this.show_ing = true;
      this.ing_obj = ing;
    },

    initActionLog: function(m, pageid) {
      if (m && pageid)
        return axios.get("/mall/member/reportV2/actionlog", {
          params: { m, pageid }
        });
    }
  },
  components: {
    Loading
  }
};
</script>
<style lang="less" scoped>
@import "../styles/mixin.less";
@import "../styles/reset.less";

//20190917修改
.serum_info_tip{
  .display_flex;
  .flex-wrap_nowrap;
  .justify-content_flex-end;
  padding-top:12/50rem;
  span,img{
    .flex_0;
    .align-self_center;
  }
  span{
    font-size:24/50rem;
    line-height:1em;
    color:@font-c-detail;
    padding-right:22/50rem;
  }
  img{
    width:14/50rem;
    height:27/50rem;
  }
}
//成分弹窗
.ing_layer {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  .ing_layer_inner {
    .border-radius(15/50rem);
    background: #fff;
    box-sizing: border-box;
    padding: 89/50rem 0px 107/50rem 0/50rem;
    width: 596/50rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .ing_name {
      font-size: 34/50rem;
      line-height: 1em;
      color: @font-c-detail;
      padding-bottom: 37/50rem;
      text-align: center;
    }
    .ing_desc {
      padding: 0 0 16/50rem 150/50rem;
      font-size: 28/50rem;
      color: font-c-3;
    }
    .ing_close_icon {
      position: absolute;
      width: 30/50rem;
      height: 30/50rem;
      top: 30/50rem;
      right: 30/50rem;
    }
  }
}
.back_btn {
  position: fixed;
  top: 30/50rem;
  left: 0;
  z-index: 99999;
  width: 118/50rem;
  height: 54/50rem;
}
.skincare_inner {
  background: @bg_c_m;
}
.skincare_head {
  padding: 105/50rem 30/50rem;
  .head_title {
    font-size: 44/50rem;
    color: @font-c-3;
    line-height: 1em;
    font-weight: bold;
    .title_sub {
      font-size: 30/50rem;
      color: @font-c-6;
      line-height: 1em;
      font-weight: normal;
    }
  }
  .second_title {
    padding: 61/50rem 0 47/50rem;
    font-size: 34/50rem;
    line-height: 1em;
    color: @font-c-3;
    font-weight: bold;
  }
  .result_sub {
    padding-bottom: 14/50rem;
    text-align: center;
    font-size: 34/50rem;
    font-weight: bold;
    line-height: 1em;
    color: @font-c-detail;
  }
  .result_sub_info {
    margin: 0 auto;
    width: 80%;
    padding-bottom: 28/50rem;
    text-align: center;
    font-size: 24/50rem;
    line-height: 28/50rem;
    color: @font-c-3;
  }
}
.head_result_part {
  background: @bg_c_l;
  box-sizing: border-box;
  padding: 45/50rem 45/50rem 29/50rem;
  .border-radius(14/50rem);
  .shadow();
  .head_result_part_title {
    font-size: 28/50rem;
    line-height: 1em;
    color: @font-c-3;
    padding-bottom: 30/50rem;
  }
  .result_info {
    padding: 0 0 30/50rem 28/50rem;
    position: relative;
    .result_info_text {
      font-size: 28/50rem;
      line-height: 30/50rem;
      color: @font-c-3;
      &:before {
        content: "";
        display: block;
        width: 5px;
        height: 5px;
        background: @font-c-0;
        .border-radius(50%);
        position: absolute;
        left: 0;
        top: 12/50rem;
        // -webkit-transform:scale(0.5);
        // transform:scale(0.5);
      }
    }

    .info_list {
      .display_flex;
      .flex-wrap_wrap;
      .justify-content_flex-start;
      padding: 20/50rem 0 0 10/50rem;
      .list_item {
        box-sizing: border-box;
        .flex_0;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        margin-right: 20/50rem;
        height: 46/50rem;
        line-height: 46/50rem;
        padding: 0 30/50rem;
        .border-radius(23/50rem);
        font-size: 24/50rem;
        color: @font-c-6;
        border: 1/50rem solid #ffc195;
        &.weak_gene {
          padding: 0 23/50rem 0 30/50rem;
        }
        span {
          .flex_0;
          .align-self_center;
          font-size: 24/50rem;
          line-height: 46/50rem;
          color: @font-c-6;
          margin-right: 8/50rem;
        }
        img {
          .flex_0;
          .align-self_center;
          width: 30/50rem;
          height: 30/50rem;
        }
      }
    }
  }
}
.skincare_ing {
  .ing_title {
    padding: 0 0 0px 30/50rem;
    font-size: 34/50rem;
    line-height: 1em;
    color: @font-c-3;
    font-weight: bold;
  }
  .ing_list {
    -webkit-overflow-x: scroll;
    overflow-x: scroll;
    .ing_list_ul {
      padding: 40/50rem 30/50rem 80/50rem;
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-start;
      .ing_list_item {
        width: 192/50rem;
        text-align: center;
        background: @bg_c_l;
        box-sizing: border-box;
        .flex_0;
        .shadow;
        .border-radius(14/50rem);
        padding-bottom: 23/50rem;
        margin-right: 20/50rem;
        .ing_list_item_pic {
          width: 192/50rem;
          height: 144/50rem;
        }
        .ing_list_item_name {
          width: 80%;
          margin: 0 auto;
          white-space: nowrap;
          overflow: hidden;
          -webkit-text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
          -ms-text-overflow: ellipsis;
          text-overflow: ellipsis;
          font-size: 24/50rem;
          // line-height:1em;
          text-align: center;
          color: @font-c-3;
        }
      }
      &:after {
        content: "";
        display: block;
        width: 1/50rem;
        height: 1/50rem;
        flex: 0 0 auto;
      }
    }
  }
}
.skincare_serum {
  padding: 0 30/50rem 73/50rem;
  .serum_title {
    padding-bottom: 40/50rem;
    font-size: 34/50rem;
    line-height: 1em;
    color: @font-c-3;
    font-weight: bold;
  }
  .serum_info {
    background: @bg_c_l;
    box-sizing: border-box;
    margin: 0 auto;
    .shadow;
    .border-radius(14/50rem);
    width: 555/50rem;
    padding: 35/50rem 35/50rem 55/50rem;
    .serum_info_pic {
      width: 100%;
      .border-radius(14/50rem);
    }
    .serum_info_name {
      padding: 40/50rem 0 33/50rem;
      font-size: 34/50rem;
      line-height: 1em;
      color: @font-c-3;
      font-weight: bold;
    }
    .serum_info_effect {
      padding-bottom: 20/50rem;
      font-size: 28/50rem;
      line-height: 1em;
      color: @font-c-3;
    }
    .serum_info_ings {
      .display_flex;
      .flex-wrap_wrap;
      .justify-content_flex-start;
      .ing {
        font-size: 24/50rem;
        color: @font-c-9;
        box-sizing: border-box;
        .flex_0;
        margin-right: 20/50rem;
        padding: 8/50rem 32/50rem;
        margin-bottom: 10/50rem;
        .border-1px;
        .border-radius(25/50rem);
      }
    }
  }
}
//护肤 步骤缩略
.skincare_rec {
  position: relative;
  padding: 90/50rem 0px 152/50rem;
  &:before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 16/50rem;
    background: @bg_c_d;
  }
  .rec_title {
    padding: 0 30/50rem 42/50rem;
    font-size: 34/50rem;
    line-height: 1em;
    font-weight: bold;
  }
  .rec_step_outer {
    padding-bottom: 67/50rem;
    -webkit-overflow-x: scroll;
    overflow-x: scroll;
    .rec_step_ul {
      padding: 0 30/50rem;
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-start;
      .rec_step_li {
        .flex_0;
        margin-right: 20/50rem;
        .display_flex;
        .flex-wrap_nowrap;
        .justify-content_flex-start;
        .step_li_info {
          .flex_0;
          .align-self_center;
          margin-right: 20/50rem;
          .step_li_pic_outer{
             width: 130/50rem;
            height: 130/50rem;
            .shadow;
            .border-radius(50%);
            .step_li_pic {
              width:100%;
              transform:scale(0.8);
          }
        }

          .step_li_name {
            padding-top: 21/50rem;
            text-align: center;
            font-size: 28/50rem;
            line-height: 1em;
            color: @font-c-3;
          }
        }
        .step_li_arrow {
          .flex_0;
          .align-self_center;
          width: 44/50rem;
          height: 28/50rem;
          margin-bottom: 30/50rem;
        }
        &:last-child .step_li_arrow,
        &:nth-child(5) .step_li_arrow {
          display: none;
        }
        &:last-child .step_li_name{
          color:@font-c-detail;
        }
      }
    }
  }
  .check_rec_detail_btn {
    margin: 0 auto;
    width: 477/50rem;
    height: 88/50rem;
    border: 1px solid #f99d9b;
    .border-radius(44/50rem);
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-center;
    span {
      .flex_0;
      .align-self_center;
      font-size: 28/50rem;
      line-height: 1em;
      color: #f99d9b;
      margin-right: 20/50rem;
    }
    img {
      .flex_0;
      .align-self_center;
      width: 17/50rem;
      height: 30/50rem;
    }
  }
}
//护肤步骤详情
.skincare_rec_detail {
  background: @bg_c_m;
  padding: 106/50rem 30/50rem 90/50rem;
  .skincare_rec_detail_list_title {
    margin-bottom: 40/50rem;
    border-bottom: 1px solid #ea5514;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    .detail_list_title_item {
      padding-bottom: 20/50rem;
      width: 50%;
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-center;
      .flex_0;
      span {
        .flex_0;
        .align-items_center;
        font-size: 0.56rem;
      }
      img {
        .flex_0;
        .align-items_center;
        width: 0.72rem;
        height: 0.72rem;
      }
      &.now {
        border-bottom: 2px solid #ea5514;
        span {
          font-size: 0.72rem;
          line-height: 1em;
          font-weight: bold;
          color: #ea5514;
          padding-right: 0.24rem;
        }
        img {
          width: 0.72rem;
          height: 0.72rem;
        }
      }
    }
  }
  .skincare_rec_detail_title {
    padding-bottom: 40/50rem;
    font-size: 44/50rem;
    line-height: 1em;
    font-weight: bold;
    color: @font-c-3;
  }
  .rec_pro_info {
    background: @bg_c_l;
    box-sizing: border-box;
    padding: 18/50rem 26/50rem 18/50rem 9/50rem;
    margin-bottom: 40/50rem;
    .shadow;
    .border-radius(14/50rem);
    width: 100%;
    .display_flex;
    .flex-wrap_nowrap;
    .justify-content_flex-justify;
    .info_item {
      .flex_0;
      .align-items_center;
    }
    .info_pic {
      width: 163/50rem;
      height: 163/50rem;
    }
    .info_detail {
      width: 358/50rem;
      padding: 21/50rem 0;
      .detail_name {
        white-space: nowrap;
        font-size: 30/50rem;
        line-height: 1em;
        color: @font-c-3;
      }
      .detail_effect {
        padding: 23/50rem 0 14/50rem;
        .display_flex;
        .flex-wrap_wrap;
        .justify-content_flex-start;
        li {
          .flex_0;
          margin-right: 24/50rem;
          font-size: 24/50rem;
          line-height: 1em;
          color: @font-c-9;
        }
      }
      .detail_tag {
        .display_flex;
        .flex-wrap_wrap;
        .justify-content_flex-start;
        li {
          box-sizing: border-box;
          padding: 8/50rem 22/50rem;
          .flex_0;
          // margin:0 24/50rem 10/50rem 0;
          font-size: 24/50rem;
          line-height: 1em;
          color: @font-c-9;
          .border-radius(25/50rem);
          border: 1/50rem solid #ff7278;
        }
      }
    }
    .info_link {
      .display_flex;
      .flex-wrap_nowrap;
      .justify-content_flex-end;
      .link_icon,
      .discount_text {
        .flex_0;
        .align-items_center;
      }
      .link_icon {
        width: 14/50rem;
        height: 27/50rem;
      }
      .discount_text {
        font-size: 24/50rem;
        color: @font-c-detail;
        padding-right: 7/50rem;
      }
    }
  }
}
.no_recommend {
  background: @bg_c_l;
  box-sizing: border-box;
  padding: 18/50rem 26/50rem 18/50rem 9/50rem;
  margin-bottom: 40/50rem;
  .shadow;
  .border-radius(14/50rem);
  width: 100%;
  .display_flex;
  .flex-wrap_nowrap;
  .justify-content_flex-start;
  .no_recommend_item {
    .flex_0;
    .align-items_center;
  }
  .no_recommend_pic {
    width: 163/50rem;
    height: 163/50rem;
  }
  .no_recommend_info {
    .no_recommend_title {
      padding-bottom: 23/50rem;
      font-size: 30/50rem;
      line-height: 1em;
      color: @font-c-3;
    }
    .no_recommend_text {
      font-size: 24/50rem;
      line-height: 1em;
      color: @font-c-6;
    }
  }
}
</style>
